const riot = require('riot');

riot.tag2('atom-google-preview-switch', '<div class="f fm"> <button class="relative border w45 h22 rounded-full transition-512 {enabled ? \'bg-primary\' : \'bg-gray_light\'}" onclick="{handleToggle}"> <div class="absolute t0 s20 circle bg-white transition-512 {enabled ? \'l23\' : \'l0\'}"><img class="s-full object-fit-contain circle block" src="/images/sns/google_color.svg"></div> </button> </div>', '', '', function(opts) {
    this.enabled = false;
    this.handleToggle = () => {
      this.enabled = !this.enabled;
      this.trigger('toggle', this.enabled);
    };
});